/**
 * Calculate age from birth date
 * Returns accurate age in years and months based on actual calendar dates
 */
export function calculateAge(birthDate: string | Date) {
  const now = new Date()
  const birth = new Date(birthDate)

  let years = now.getFullYear() - birth.getFullYear()
  let months = now.getMonth() - birth.getMonth()

  // Adjust if birth month hasn't occurred yet this year
  if (months < 0) {
    years--
    months += 12
  }

  // Adjust if birth day hasn't occurred yet this month
  if (now.getDate() < birth.getDate()) {
    months--
    if (months < 0) {
      years--
      months += 12
    }
  }

  const totalMonths = years * 12 + months

  return {
    years,
    months,
    totalMonths,
  }
}

/**
 * Format age as string
 * Examples:
 * - "2 ปี 3 เดือน"
 * - "8 เดือน"
 * - "3 ปี"
 */
export function formatAge(birthDate: string | Date): string {
  const { years, months } = calculateAge(birthDate)

  if (years === 0) {
    return `${months} เดือน`
  } else if (months === 0) {
    return `${years} ปี`
  } else {
    return `${years} ปี ${months} เดือน`
  }
}
